const mixin = {
    methods: {
        errorDisplay: function (error) {
            if (error) {
                try {
                    return error.response.data.detail;
                } catch (err) {
                    return 'Unknown error';
                }
            }
            return null;
        },
    }
}

export default mixin;